export enum Language {
    FR = "fr",
    EN = "en",
    IT = "it",
    DE = "de",
}
